import { resolveThoughtActivityKind } from './thoughtActivityKinds'

export function timelinePhaseMeta(publicView) {
  const phaseTitles = publicView.phases.map((phase) => phase.title)
  const phaseKinds = publicView.phases.map((phase) =>
    resolveThoughtActivityKind({ category: phase.category, title: phase.title }),
  )
  return { phaseTitles, phaseKinds }
}
